<script>
    export default {
        props: {
            withQueue: {
                type: Array,
                default: []
            },
        },
        data() {
            return {
                baseUrl: Scoop.baseUrl,
                queue: []
            }
        },
        created() {
            this.queue = this.withQueue;
            this.listenForEvents();
        },
        computed: {
            canBeFlushed() {
                let canBeFlushed = false;

                _.each(this.queue, (media) => {
                    if (this.allFormatsAreGenerated(media)) {
                        canBeFlushed = true;
                        return false; // quit _.each
                    }
                });

                return canBeFlushed;
            }
        },
        methods: {
            listenForEvents() {
                if (!window.Echo) {
                    console.log('Push deactivated')
                    return null;
                }

                window.Echo.private(`media.queue`)
                    .listen('\\Scoop\\MediaServer\\Events\\Broadcasting\\PushCreatedIndexToQueue', (media) => {
                        this.updateMedia(media);
                    })
                    .listen('\\Scoop\\MediaServer\\Events\\Broadcasting\\PushCreatedFormatToQueue', (media) => {
                        this.updateMedia(media);
                    });
            },
            updateMedia(media) {
                let idx = _.findIndex(this.queue, {id: media.id});

                if (idx !== -1) {
                    Vue.set(this.queue, idx, media);
                } else {
                    this.queue.push(media);
                }
            },
            allFormatsAreGenerated(media) {
                let cntGenerated = 0;
                _.each(media.queuedFormats, (format) => {
                    cntGenerated += format && format.statuscode === 2 ? 1 : 0;
                });

                return cntGenerated === _.size(media.queuedFormats);
            },
            flushMedia() {
                this.queue = _.filter(this.queue, (media) => {
                    return !this.allFormatsAreGenerated(media);
                });
            },
            classByStatusCode(statusCode) {
                switch (statusCode) {
                    case 1: return 'label label-danger'; // STATUS_CODE_FAILED
                    case 2: return 'label label-success'; // STATUS_CODE_AVAILABLE
                    case 3: return 'label label-info'; // STATUS_CODE_GENERATING
                    case 4: return 'label label-info'; // STATUS_CODE_SCHEDULED
                    case 5: return 'label label-warning'; // STATUS_CODE_UNKNOWN
                }

                return 'label label-info';
            },
            iconByStatusCode(statusCode) {
                switch (statusCode) {
                    case 1: return 'fa fa-exclamation-triangle'; // STATUS_CODE_FAILED
                    case 2: return 'fa fa-check-circle'; // STATUS_CODE_AVAILABLE
                    case 3: return 'fa fa-spinner fa-spin'; // STATUS_CODE_GENERATING
                    case 4: return 'fa fa-spinner fa-spin'; // STATUS_CODE_SCHEDULED
                    case 5: return 'fa fa-exclamation-triangle'; // STATUS_CODE_UNKNOWN
                }

                return 'fa fa-spinner fa-spin';
            }
        },
    }
</script>

<template>
    <div v-if="queue && queue.length > 0" class="row wrapper">
        <div class="col-sm-12">
            <div class="ibox float-e-margins">
                <div class="ibox-title">
                    <h5 v-text="__('scoop-os.media.import.upload_status')"></h5>
                    <div class="ibox-tools">
                        <a @click="flushMedia"
                           class="btn btn-primary btn-xs"
                           :disabled="!canBeFlushed"
                           v-text="__('scoop-os.media.import.flush_uploaded')"></a>
                    </div>
                </div>
                <div class="ibox-content">
                    <table class="table table-striped">
                        <thead>
                        <tr>
                            <th v-text="__('scoop-os.media.import.tr_index')"></th>
                            <th v-text="__('scoop-os.media.import.tr_file')"></th>
                            <th v-text="__('scoop-os.media.import.tr_formats')"></th>
                            <th v-text="__('scoop-os.media.import.tr_status')"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in queue">
                            <td v-text="item.index_id"></td>
                            <td v-text="item.fullpath"></td>
                            <td>
                                <template v-for="(format, formatName) in item.queuedFormats">
                                    <span
                                            :class="classByStatusCode(format ? format.statuscode : null)"
                                            style="margin-right: 3px; display: inline-block;">
                                        {{ formatName }}
                                        <i :class="iconByStatusCode(format ? format.statuscode : null)" aria-hidden="true"></i>
                                    </span>
                                </template>
                            </td>
                            <td>
                                <template v-if="allFormatsAreGenerated(item)">
                                    <a :href="baseUrl + '/mediaserver/media/'+item.id+'/edit'">
                                        <i class="fa fa-picture-o" aria-hidden="true"></i>
                                        <i v-text="__('scoop-os.media.import.upload_ready')"></i>
                                    </a>
                                </template>
                                <template v-else>
                                    <i v-text="__('scoop-os.media.import.upload_generating_formats')"></i>
                                </template>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    #image-upload {
        border: dashed 1px #ccc;
        min-height: 263px;
        line-height: 135px;

        .dz-message {
            color: #b5b5b5;
        }
    }
</style>